import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';
import useAPI from '@/hooks/useAPI';
import {formDownload} from '@/b2c/api';
import {mapWithIndex} from '@/util';
import Icon from '@/views/shared/Icon';

const FormDownload = ({plan, setShowFDtab}) => {
  const {t: tr, i18n: i18nCtx} = useTranslation('planDetail');
  const currentLang = i18nCtx.language;
  const langs = {en: 6, zh: 7, ja: 8, kr: 9};

  const provider = plan.providerCodeForApi;
  const product = plan.productCodeForApi;

  const formData = {
    provider_code: `${provider}`,
    product_type_code: `${product}`,
    client_lang: langs[currentLang],
  };

  const {result, error, trigger} = useAPI(formDownload, {
    pending: true,
    throwError: false,
  });
  const {data} = R.pathOr({}, ['data'], result); // vendor response structure contains "data" key

  useEffect(
    () => {
      setShowFDtab(false); // default back to hidden
      trigger(formData);
    },
    [plan]
  );

  if (!result) {
    return null;
  }

  if (error) {
    return 'error';
  }

  if (!data) {
    return <span>Not Found</span>;
  }

  if (data) {
    setShowFDtab(true); // show tab only if data returned
  }

  return (
    <>
      <h4>{tr('form_download')}</h4>
      <table className='wide list text-left'>
        <tbody>
          <tr>
            <th>{tr('form_download_title')}</th>
            <th>{tr('form_download_link')}</th>
          </tr>
          {mapWithIndex((doc, idx) => (
            <tr key={idx}>
              <td>
                {doc.product_type_title} ({doc.provider_title}) - {doc.title}
                <span style={{color: '#A07748'}}>
                  {' '}
                  {doc.form_type === 'original' && <Icon icon='file-alt' />}
                  {doc.form_type === 'copy' && <Icon icon='print' />}
                </span>
              </td>
              <td>
                <a
                  href={doc.document}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  download
                </a>
              </td>
            </tr>
          ))(data)}
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <br />
      <span style={{color: '#A07748'}}>
        <Icon icon='file-alt' /> - {tr('form_download_original')}{' '}
        <Icon icon='print' /> - {tr('form_download_copy')}
      </span>
    </>
  );
};

export default FormDownload;
